import { useAppSelector } from '../../../../state/hooks'
import {
  selectSaleFinals,
  selectSalePayments,
} from '../../../../state/slices/currentSale/currentSaleSlice'
import { LspCashDiscountBlockedSale } from '../isPartialAmountTendered'

/** Sale slice passed to {@link isLspCashDiscountBlocked}. */
export const useLspCashDiscountBlockedSale = (): LspCashDiscountBlockedSale => {
  const finals = useAppSelector(selectSaleFinals)
  const payments = useAppSelector(selectSalePayments)
  const payAccountBalance = useAppSelector(
    state => state.currentSale.payAccountBalance
  )
  const returnFor = useAppSelector(state => state.currentSale.returnFor)

  return { finals, payments, payAccountBalance, returnFor }
}
